var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"uc-tab",class:{ selected: _vm.isSelected },on:{"click":_vm.handleClick}},[_c('div',[_vm._v(_vm._s(_vm.title)),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }